import { connect } from 'react-redux';

import { hasSession } from 'core/selectors';
import { pingAPI, requestBandwidth, saveNetworkMetrics } from 'core/slices/network';
import { NetworkProvider } from '../../../context/NetworkContext';

export default connect(
    state => ({
        isLoggedIn: hasSession(state),
    }),
    {
        pingAPI,
        requestBandwidth,
        saveNetworkMetrics,
    },
)(NetworkProvider);
